import builder from '../builder';
import ListBullets1 from '../../streamline-icons/light/list-bullets-1.svg';

export default builder('IconListBullets1Light', ListBullets1);
